import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from 'hellospa/components/global-nav/global-nav.scss';
import { getBrandShortName, siteCodeSign } from 'js/sign-components/common/brand';
import { UIIcon } from '@dropbox/dig-icons';
import { Twinkle2Line } from '@dropbox/dig-icons/assets';
import { AccessoryBadge } from '@dropbox/dig-components/badges';

type Args = {
    extra?: string
}
const SignAiChatItem = ({ extra }: Args) => {
  return (
    <>
      <FormattedMessage
        id=''
        description='Global menu item for sign AI'
        defaultMessage='{brandName} AI {extra}'
        values={{
          brandName: getBrandShortName(siteCodeSign),
          extra,
        }} />
      <UIIcon src={Twinkle2Line} />
      <AccessoryBadge status="attention" className={styles.betaTag}>
        <FormattedMessage
          id=''
          description='A tag next to feature which is currently in alpha'
          defaultMessage='Alpha' />
      </AccessoryBadge>
    </>
  );
};

export default SignAiChatItem;
